import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import {
  PendingOrderListSortField,
  pendingOrderTrackingUrl,
  pendingOrderUrl,
  PendingOrderUrlQueryParams
} from "@saleor/PendingOrder/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import PendingOrderView from "./views/PendingOrderView";

const PendingOrderSection = () => {
  const intl = useIntl();

  const PendingOrderViewSection: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: PendingOrderUrlQueryParams = asSortParams(
      qs,
      PendingOrderListSortField,
      PendingOrderListSortField.poNo
    );
    return <PendingOrderView params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.inquiry1Admin)} />
      <Switch>
        <Route exact path={pendingOrderUrl} render={PendingOrderViewSection} />
        <Route
          exact
          path={pendingOrderTrackingUrl}
          render={PendingOrderViewSection}
        />
      </Switch>
    </>
  );
};

export default PendingOrderSection;
